<template>
  <div class="storefinder">
    <!-- Result list -->
    <section class="contentWrapper storefinder__resultSection" ref="resultSection">
      <!-- Stores -->
      <article v-if="stores.length" class="offsetLeft-noOuterGap--1 offsetRight-noOuterGap--1 storefinder__resultListWrapper">
        <header class="headline--3 storefinder__resultListHeader">{{ defaultResultListTitle }}</header>
        <div class="storefinder__resultList">
          <StorefinderResult
            class="storefinder__resultList__result"
            v-for="(store, key) in storesArray"
            :store="store"
            :key="key"
            @contact="onContact"
            :static-text-phone="staticTextPhone"
            :static-text-web="staticTextWeb"
            :static-text-email="staticTextEmail"
            :static-text-directions="staticTextDirections"
            :static-text-contact-button="staticTextContactButton"
          />
        </div>
      </article>

    </section>

    <StorefinderContactDialog
      ref="contactDialog"
      :contact="selectedContact"
      :contactModalTitle="contactModalTitle"
      :contactMessageLabel="contactMessageLabel"
      :contactMessagePrefix="contactMessagePrefix"
      :contactMessageSuffix="contactMessageSuffix"
      :staticTextFormSalutation="staticTextFormSalutation"
      :staticTextFormSalutationMister="staticTextFormSalutationMister"
      :staticTextFormSalutationMisses="staticTextFormSalutationMisses"
      :staticTextFormName="staticTextFormName"
      :staticTextFormStreetNumber="staticTextFormStreetNumber"
      :staticTextFormZipCode="staticTextFormZipCode"
      :staticTextFormPhone="staticTextFormPhone"
      :staticTextFormEmail="staticTextFormEmail"
      :staticTextFormDataprotection="staticTextFormDataprotection"
      :staticTextFormSubmit="staticTextFormSubmit"
      :staticTextFormSuccess="staticTextFormSuccess"
      :staticTextFormError="staticTextFormError"
    >
      <template v-slot:modal-close-text>{{ staticTextCloseWindow }}</template>
    </StorefinderContactDialog>
  </div>
</template>

<script>
  export default {
    name: 'storefinder-list',

    props: [
      'stores',
      'defaultResultListTitle',
      'contactModalTitle',
      'contactMessageLabel',
      'contactMessagePrefix',
      'contactMessageSuffix',
      'staticTextZipOrCity',
      'staticTextCountry',
      'staticTextPhone',
      'staticTextWeb',
      'staticTextEmail',
      'staticTextDirections',
      'staticTextContactButton',
      'staticTextCloseWindow',
      'staticTextFormSalutation',
      'staticTextFormSalutationMister',
      'staticTextFormSalutationMisses',
      'staticTextFormName',
      'staticTextFormStreetNumber',
      'staticTextFormZipCode',
      'staticTextFormPhone',
      'staticTextFormEmail',
      'staticTextFormDataprotection',
      'staticTextFormSubmit',
      'staticTextFormSuccess',
      'staticTextFormError',
    ],

    data() {
      return {
        errors: [],
        selectedContact: null,
        pages:{},
        visibility:{},
        storesArray: [],
      };
    },

    methods: {
      onContact(store) {
        this.selectedContact = store;
        this.$refs.contactDialog.toggleModal();
      },
      byDistance(a, b) {
        return a.distance - b.distance;
      },
    },
    computed: {

    },

    mounted() {
      this.storesArray = (typeof this.stores !== "object") ? JSON.parse(this.stores) : this.stores;
    },
  };
</script>
